var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.23 14.276a11.217 11.217 0 0 0-8.656-7.784c-.519.298-1.154.532-1.81.774-1.827.673-3.806 1.402-3.836 3.731-.042 3.228 1.885 3.974 3.043 4.422.075.028.147.056.214.083.988.395 2.746-.19 4.56-.794.234-.079.47-.157.704-.233 1.522-.497 3.954-.576 5.781-.2zm.412 2.08a11.16 11.16 0 0 1-2.936 8.767c-.07-.01-.143-.016-.22-.024-1.022-.1-2.576-.25-3.53-2.594-1.07-2.632 1.027-4.951 2.588-5.71.754-.366 2.466-.458 4.098-.44zM15.585 4.261c-.583.086-2.36.487-4.373 1.267-1.728.53-3.3 1.394-4.632 2.512a9.87 9.87 0 0 0-1.433 1.35c-2.944 3.434-3.345 7.404-3.078 9.991.267 2.588 2.542 6.736 5.665 8.431.176.096.357.19.542.282A13.502 13.502 0 0 0 15.367 30h.133a12.46 12.46 0 0 0 4.79-.95c3.607-1.157 5.587-3.075 6.135-3.912-.204.017-.515.036-.864.048 1.744-2.128 2.783-4.808 2.783-7.72 0-.357-.015-.71-.046-1.059.438.023.835.05 1.161.077.014-.223-.25-.822-1.375-1.514-.977-4.622-4.614-8.322-9.318-9.578.785-1.142.927-2.604.88-3.316-.197-.197-.358.014-.618.352-.153.2-.34.443-.587.674-.669.624-1.65.981-2.855 1.16z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuna);
export default __webpack_public_path__ + "static/media/LUNA.4ee3fb466efa615f3c2a99f7062d1476.svg";
export { ForwardRef as ReactComponent };